document.addEventListener('DOMContentLoaded', () => {
  const target = document.querySelector('.sticky-add-to-cart');
  
  if (!target) {
    return;
  }

  const allSubmitBtns = Array.from(
    document.querySelectorAll('.product-form__submit, button[name="add"]')
  );
  const mainAtcButton = allSubmitBtns.find((btn) => !btn.closest('.sticky-add-to-cart'));

  if (!mainAtcButton) {
    return;
  }

  const header = document.querySelector(
    '.section-header, header, .header-wrapper, .shopify-section-header'
  );
  const headerHeight = header ? header.offsetHeight : 80;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting && entry.boundingClientRect.top <= headerHeight) {
        target.classList.add('fixed-bottom');
      } else {
        target.classList.remove('fixed-bottom');
      }
    },
    {
      rootMargin: `-${headerHeight}px 0px 0px 0px`,
      threshold: 0
    }
  );

  observer.observe(mainAtcButton);
});
